import styles from './ManageUserProfile.module.css';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';
import Input from '../common/input/Input';
import { USER_ROLES } from './../../constants/UserRoles.const';
import { useEffect } from 'react';
import { createNewUser, updateUserProfile } from '../../services/User.service';
import { setNotificationMessageSelector } from '../../hooks/store/setters';
import { useAppStore } from './../../hooks/store/useAppStore';

const userRoles = Object.keys(USER_ROLES).map(role => ({
    label: role,
    value: role,
}))

const userForm = {
    userName: '',
    email: '',
    userRole: ''
}

const convertToFormData = (user) => {
    if (!user) return userForm;
    
    return { ...user }
}

const ManageUserProfile = ({ show, onClose, user, viewMode=false }) => {
    
    const [formData, setFormData] = useState({});
    
    const setNotificationMessage = useAppStore(setNotificationMessageSelector);
    
    useEffect(() => {
        setFormData(convertToFormData(user))
    }, [user])
    
    const handleInputChange = ({ target: { name, value } }) => {
        setFormData({
            ...formData,
            [name]: value
        })
    }
    
    const saveUserProfile = async () => {
        console.log('save user profile', formData);
        try {
            const result = await updateUserProfile(formData)
            onClose(result)
        } catch (error) {
            console.log('update failed ', error);
        }
    }
    
    const createUserProfile = async () => {
        console.log('create new user profile', formData);
        try {
            const result = await createNewUser(formData)
            onClose({
                ...result,
                newlyAdded: true
            })
        } catch (error) {
            console.log('create user failed ', error);
            const msg = error && error.message ? error.message : 'Something went wrong'
            setNotificationMessage(msg)
        }
    }

    
    if (!show) return null;
    
    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            contentClassName={styles.userProfileModal}
        >
            <Modal.Header closeButton>
                <Modal.Title>User Profile</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    viewMode ? (<>
                        <div className={styles.userInfo}>
                            <label>Name : </label>
                            <span> { user.userName } </span>
                        </div>
                        <div className={styles.userInfo}>
                            <label>Email : </label>
                            <span> { user.email } </span>
                        </div>
                        <div className={styles.userInfo}>
                            <label>Role : </label>
                            <span> { user.userRole || "user" } </span>
                        </div>
                    </>) : (<>
                        <div className={styles.userInfo}>
                            <Input
                                label="User Name"
                                placeholder="username"
                                name="userName"
                                value={formData.userName}
                                onChange={handleInputChange}
                            ></Input>
                        </div>
                        <div className={styles.userInfo}>
                            <Input
                                label="Email"
                                placeholder="email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                disabled={!!user}
                            ></Input>
                        </div>
                        <div className={styles.userInfo}>
                            <Input
                                label="Role"
                                placeholder="role"
                                name="userRole"
                                type="select"
                                options={userRoles}
                                value={formData.userRole}
                                onChange={handleInputChange}
                            ></Input>
                        </div>
                    </>)
                }
            </Modal.Body>  
            
            <Modal.Footer>
                {
                    !viewMode && user && <Button variant="warning"
                        onClick={saveUserProfile}
                    >Update Profile</Button>
                }
                {
                    !viewMode && !user && <Button variant="warning"
                        onClick={createUserProfile}
                    >Create Profile</Button>
                }
                <Button variant="outline-secondary"
                    onClick={onClose}
                >Close</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ManageUserProfile;